export const isNumericCellValueValid = (value: string | number | undefined): boolean => {
    if (typeof value === "undefined") {return false;}

    const conditions: boolean[] = [
        typeof value === "string" && Number(value) > 0,
        typeof value === "number" && value > 0,
    ];

    return conditions.some(Boolean);
};
